import React from "react"
import SeoLandingPage from "./SeoLandingPage"
import { SEO_KEYWORDS_EXTRA } from "../../seo/extraKeywords"

export default function BedBpedAndhraGuidance() {
  return (
    <SeoLandingPage
      path="/andhra-bed-bped-admission-odisha"
      title="Andhra B.Ed / BP.Ed Admission Guidance for Odisha Students | Devbhumi"
      description="Odisha students ke liye Andhra B.Ed/BP.Ed admission counselling + coaching. Eligibility, admission processing, books and online classes with Bhadrak office support."
      keywords={`Andhra B.Ed admission Odisha students, Andhra BP.Ed guidance Odisha, Nagarjuna University B.Ed Odisha help, Andhra Pradesh B.Ed for Odisha, ${SEO_KEYWORDS_EXTRA}`}
      h1="Andhra B.Ed / BP.Ed Admission Guidance (Odisha Students)"
      intro="If you are an Odisha student searching for Andhra B.Ed/BP.Ed admission guidance, we provide counselling, eligibility help, admission processing support, study materials and online coaching. Offline support is available via our Bhadrak office."
      bullets={[
        "Counselling for Andhra B.Ed/BP.Ed admissions",
        "Eligibility & document checklist support",
        "Admission processing guidance end-to-end",
        "Online coaching/classes + study material guidance",
        "Book distribution support via office",
        "Support for students across Odisha (Bhadrak, Balasore, Baripada, Mayurbhanj)",
      ]}
      areaServed={[
        { "@type": "State", name: "Odisha" },
        { "@type": "State", name: "Andhra Pradesh" },
        { "@type": "City", name: "Bhadrak" },
      ]}
      faqs={[
        {
          q: "Do you provide coaching along with admission guidance?",
          a: "Yes. We provide admission counselling plus coaching support through online classes and study materials.",
        },
        {
          q: "Can students from Bhadrak/Balasore visit for help?",
          a: "Yes. Students can visit our Bhadrak office for counselling, documents and books.",
        },
        {
          q: "How do I contact you?",
          a: "Call/WhatsApp us for counselling. We will guide you on eligibility, documents and next steps.",
        },
      ]}
    />
  )
}

